import gql from "graphql-tag";

export const GET_ADMIN_USER_SETTINGS = gql`
  query getUserProfile($getUserProfileInput: GetUserProfileInput!) {
    getUserProfile(getUserProfileInput: $getUserProfileInput) {
      ... on GetUserProfileErrorOutput {
        errorReason
      }
      ... on GetUserProfileOutput {
        profile {
          firstName
          lastName
          birthday
          postalAddress {
            address
            zipcode
            city
            country
          }
        }
      }
    }
  }
`;


export const GET_DEVICE_COMMUNICATE_SETTINGS = gql`
  query GetDeviceCommunicateSettings($getDeviceSettingsInput: GetDeviceSettingsInput!) {
    getDeviceSettings(getDeviceSettingsInput: $getDeviceSettingsInput) {
      ... on GetDeviceSettingsErrorOutput {
        errorReason
      }
      ... on GetDeviceSettingsOutput {
        settings {
          mailUnfilteredAttachmentAddedToDocuments
          mailFilteredAttachmentAddedToDocuments
          mailDisplaySignature
          mailUnreadFirst
          mailReadFullScreen
          mailDraftRemovalDelayInDays
          mailSpamRemovalDelayInDays
          mailSignature
        }
      }
    }
  }
`;

export const GET_DEVICE_SOUND_SETTINGS = gql`
  query GetDeviceSoundSettings($getDeviceSettingsInput: GetDeviceSettingsInput!) {
    getDeviceSettings(getDeviceSettingsInput: $getDeviceSettingsInput) {
      ... on GetDeviceSettingsErrorOutput {
        errorReason
      }
      ... on GetDeviceSettingsOutput {
        settings {
          soundOnButtonPush,
          soundOnKeyPush,
          soundOnAllowedMailReception,
          soundOnForbiddenMailReception,
          soundOnVideoCall
        }
      }
    }
  }
`;

export const GET_DEVICE_DISPLAY_SETTINGS = gql`
  query GetDeviceDisplaySettings($getDeviceSettingsInput: GetDeviceSettingsInput!) {
    getDeviceSettings(getDeviceSettingsInput: $getDeviceSettingsInput) {
      ... on GetDeviceSettingsErrorOutput {
        errorReason
      }
      ... on GetDeviceSettingsOutput {
        settings {
          interfaceMode,
          theme,
          screenBrightness,
          standByDelay,
          screenLock
        }
      }
    }
  }
`;

export const GET_STANDBY_DELAYS = gql`
  query GetStandbyDelays($getStandbyDelaysInput: GetStandbyDelaysInput!) {
    getStandbyDelays(getStandbyDelaysInput: $getStandbyDelaysInput) {
      ... on GetStandbyDelaysErrorOutput {
        errorReason
      }
      ... on GetStandbyDelaysOutput {
        delays {
          label,
          value
        }
      }
    }
  }
`;